import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { IPictureData } from '../../shared/components/picture/picture.component';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { timer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';

interface IGetMaterialsPanelData {
  title: IUProperty<string>;
  image: IUProperty<IPictureData>;
  buttonText: IUProperty<string>;
  file: IUProperty<IMediaVm>;
  cookiePolicyPageUrl: string;

  titleStyleSettings?: ITitleStyleSettings;
}

interface IMediaVm {
  id: number;
}

interface IGetMaterialsPanelResponseData {
  emailSent: boolean;
}

@Component({
  selector: "app-get-materials-panel",
  templateUrl: "./get-materials-panel.component.html",
  styleUrls: ["./get-materials-panel.component.less"],
})
export class GetMaterialsPanelComponent implements OnInit {
  @Input() data: IGetMaterialsPanelData;
  @ViewChild('titleEl', { static: false }) titleEl: ElementRef<HTMLElement>;

  formText = {
    name: this.translateService.instant("getMaterialsPanel.InputField.Name"),
    email: this.translateService.instant("getMaterialsPanel.InputField.Email")
  }
  privacyPolicy = {
    text: this.translateService.instant("getMaterialsPanel.PrivacyPolicy.Text")
  }
  getMaterialsGroup: FormGroup;
  errMsg: string = null;
  succMsg: string = null;
  requestSuccess: boolean = false;

  constructor(private http: HttpClient,
    private translateService: TranslateService) { }

  ngOnInit(): void {
    this.getMaterialsGroup = new FormGroup({
      name: new FormControl("", Validators.required),
      email: new FormControl("", Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')])),
      privacyPolicy: new FormControl(false, Validators.requiredTrue)
    });
  }

  ngAfterViewInit(): void {
    applyTitleSettings(this.data, this.titleEl);
  }

  sendRequest(event) {
    event.preventDefault();
    this.errMsg = "";

    if (!this.getMaterialsGroup.invalid) {
      var data = { ...this.getMaterialsGroup.value, fileId: this.data.file.value.id };

      this.http.post('ubaseline/api/getMaterialsPanel/sendRequest', data).subscribe(
        (data: IGetMaterialsPanelResponseData) => {
          if (!data.emailSent) {
            this.errMsg = this.translateService.instant("getMaterialsPanel.EmailError");
            return;
          }

          this.getMaterialsGroup.reset();
          this.successOnSend()
        },
        error => console.log('An error has occured', error)
      )
    } else {
      if (!this.getMaterialsGroup.value.privacyPolicy) {
        this.errMsg = this.translateService.instant("demoPanel.ErrorMessage.PrivacyPolicy");
      } else if (this.getMaterialsGroup.controls.name.status === "INVALID") {
        this.errMsg = this.translateService.instant("demoPanel.ErrorMessage.MissingFields");
      } else {
        this.errMsg = this.translateService.instant("demoPanel.ErrorMessage.Email");
      }
    }
  }

  successOnSend() {
    this.startTimer();
    this.requestSuccess = true;
    this.succMsg = this.translateService.instant("getMaterialsPanel.SuccessMessage.OnSend");
  }

  startTimer() {
    let countDown;
    let timeLeft: number = 2;
    const source = timer(1000, 1000);
    countDown = source.subscribe(val => {
      timeLeft--;
      if (timeLeft === 0) {
        this.requestSuccess = false;
        countDown.unsubscribe();
      }
    });
  }
}
